import { Box, createToaster, Portal, Spinner, Stack, Toast, Toaster as ChakraToaster } from '@chakra-ui/react';
import NotificationToast from '@components/cockpit/toast/notification/NotificationToast';
// import { AutoDismissToast } from '@components/common/AutoDismissToast';
import { appIntl } from '@components/locale/IntlGlobalProvider';
import {
  defaultToastConfig,
  errorToastOptions,
  infoToastOptions,
  successToastOptions,
  ToastStatusEnum,
  warningToastOptions,
} from '@components/ui/toaster/toaster.constant';
import { css } from '@emotion/react';

import { NotificationType } from '@/types/data/data.types';
import { SourceNameEnum } from '@/types/map.types';

export const toaster = createToaster(defaultToastConfig);

export function createToast(message: string, type: ToastStatusEnum = ToastStatusEnum.INFO, id?: string): void {
  const withId = id ? { id } : {};
  switch (type) {
    case ToastStatusEnum.SUCCESS:
      toaster.create({ ...successToastOptions, title: message, ...withId });
      break;
    case ToastStatusEnum.ERROR:
      toaster.create({ ...errorToastOptions, title: message, ...withId });
      break;
    case ToastStatusEnum.WARNING:
      toaster.create({ ...warningToastOptions, title: message, ...withId });
      break;
    case ToastStatusEnum.INFO:
    default:
      toaster.create({ ...infoToastOptions, title: message, ...withId });
  }
}

export function createErrorToastFromTradId(tradId: string, values?: Record<string, string>): void {
  createToast(appIntl().formatMessage({ id: tradId }, values), ToastStatusEnum.ERROR);
}

export function createSensorLayerErrorToast(source: SourceNameEnum) {
  createErrorToastFromTradId('error.sensorReplay.layer', {
    name: appIntl().formatMessage({ id: `error.sensorReplay.${source}` }),
  });
}

type NotificationToastMeta = {
  notification: NotificationType;
  onClose: () => void;
};

export const Toaster = () => {
  return (
    <Portal>
      <ChakraToaster
        toaster={toaster}
        insetInline={{ mdDown: '4' }}
        gap="10px"
        maxWidth="360px"
        maxHeight="100vh"
        height="100%"
        width="100%"
        overflowY="auto"
        css={css({
          scrollbarWidth: 'none',
          '&::-webkit-scrollbar': {
            display: 'none',
          },
          pointerEvents: 'none',
        })}
      >
        {(toast) => {
          if (toast.type === 'notification') {
            const { notification, onClose } = toast.meta as NotificationToastMeta;
            return (
              <Box
                key={toast.id}
                onMouseEnter={() => toaster.pause(toast.id)}
                onMouseLeave={() => toaster.resume(toast.id)}
                pointerEvents="auto"
              >
                {/*<AutoDismissToast key={notification.id} onClose={() => onClose(notification.id)}>*/}
                <NotificationToast notification={notification} onClose={onClose} />
                {/*</AutoDismissToast>*/}
              </Box>
            );
          }
          return (
            <Toast.Root width={{ md: 'sm' }} padding="standardS">
              {toast.type === 'loading' ? <Spinner size="sm" color="blue.solid" /> : <Toast.Indicator />}
              <Stack gap={1} flex={1} maxWidth="100%">
                {toast.title && <Toast.Title>{toast.title}</Toast.Title>}
                {toast.description && <Toast.Description textStyle="screenStd">{toast.description}</Toast.Description>}
              </Stack>
              {toast.action && <Toast.ActionTrigger>{toast.action.label}</Toast.ActionTrigger>}
              {toast.closable && <Toast.CloseTrigger cursor="pointer" />}
            </Toast.Root>
          );
        }}
      </ChakraToaster>
    </Portal>
  );
};
